module.exports = __webpack_public_path__ + "media/images/front/icons/logo_jcr-d3c24e8438cbd28daff79401369d41d6.png";